import type { PlatformUser } from '@sirius/contracts/admin'
import { useTranslation } from 'react-i18next'
import { Badge } from '~/components/ui/badge'
import { roleLabel, statusLabel } from './userFormat'

const ROLE_VARIANTS = {
  admin: 'default',
  technician: 'secondary',
} as const

export function UserRoleBadge({
  platformRole,
}: Pick<PlatformUser, 'platformRole'>) {
  const { t } = useTranslation()
  return (
    <Badge
      variant={platformRole === null ? 'outline' : ROLE_VARIANTS[platformRole]}
    >
      {roleLabel(platformRole, t)}
    </Badge>
  )
}

export function UserStatusBadge({ banned }: Pick<PlatformUser, 'banned'>) {
  const { t } = useTranslation()
  return (
    <Badge variant={banned ? 'destructive' : 'secondary'}>
      {statusLabel(banned, t)}
    </Badge>
  )
}
